"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestQuery = exports.MAX_API_RESULTS = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
exports.MAX_API_RESULTS = 5000;
function getGTLTValue(value) {
    if (typeof value !== 'string') {
        return value;
    }
    if (value.length !== 24) {
        return value;
    }
    var date = new Date(value);
    if (isNaN(date.getTime())) {
        return value;
    }
    return date;
}
var IkeRestQuery = /** @class */ (function () {
    function IkeRestQuery(core, ike, sessionToken, departmentId, log) {
        this.limitResults = 200;
        this.skippedResults = 0;
        this.where = {};
        this.sortField = null;
        this.core = core;
        this.log = log;
        this.ike = ike;
        this.sessionToken = sessionToken;
        this.departmentId = departmentId;
    }
    /**
     * Sort the query based off the fieldName;
     *
     * @param fieldName Sort field name
     * @param direction 1 = ascending, -1 = descending
     */
    IkeRestQuery.prototype.sort = function (fieldName, direction) {
        if (direction === void 0) { direction = core_api_1.IkeQuerySort.ASC; }
        if (this.sortField == null) {
            this.sortField = {};
        }
        this.sortField[fieldName] = direction;
        return this;
    };
    IkeRestQuery.prototype.equal = function (key, value) {
        this.where[key] = value;
        return this;
    };
    IkeRestQuery.prototype.in = function (key, value) {
        this.where[key] = { $in: value };
        return this;
    };
    IkeRestQuery.prototype.gt = function (key, value) {
        var $gt = getGTLTValue(value);
        this.where[key] = { $gt: $gt };
        return this;
    };
    IkeRestQuery.prototype.lt = function (key, value) {
        var $lt = getGTLTValue(value);
        this.where[key] = { $lt: $lt };
        return this;
    };
    IkeRestQuery.prototype.limit = function (limit) {
        this.limitResults = limit;
        if (this.limitResults > exports.MAX_API_RESULTS) {
            throw new Error('QUERY_HUGE_LIMIT');
        }
        return this;
    };
    IkeRestQuery.prototype.skip = function (skip) {
        this.skippedResults = skip;
        return this;
    };
    IkeRestQuery.prototype.find = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var startTime, queryObj, response, duration, documents;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        startTime = Date.now();
                        queryObj = { where: this.where, limit: this.limitResults, skip: this.skippedResults };
                        if (this.sortField) {
                            queryObj['order'] = this.sortField;
                        }
                        return [4 /*yield*/, this.core.action("".concat(this.ike.actionName, ".query"), queryObj, this.sessionToken, this.departmentId)];
                    case 1:
                        response = _a.sent();
                        duration = Date.now() - startTime;
                        documents = response.results;
                        this.log.info({
                            object: this.ike.className,
                            found: documents.length,
                            keys: Object.keys(this.where).join(', '),
                            duration: duration
                        }, 'find');
                        return [2 /*return*/, documents];
                }
            });
        });
    };
    IkeRestQuery.prototype.findAll = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var startTime, LIMIT, queryResLen, queryObj, response, duration, documents, count;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        startTime = Date.now();
                        LIMIT = exports.MAX_API_RESULTS;
                        queryResLen = LIMIT;
                        documents = [];
                        count = 0;
                        _a.label = 1;
                    case 1:
                        if (!(queryResLen >= LIMIT)) return [3 /*break*/, 3];
                        queryObj = { where: this.where, limit: LIMIT, skip: LIMIT * count };
                        if (this.sortField) {
                            queryObj['order'] = this.sortField;
                        }
                        return [4 /*yield*/, this.core.action("".concat(this.ike.actionName, ".query"), queryObj, this.sessionToken, this.departmentId)];
                    case 2:
                        response = _a.sent();
                        if (documents.length > 0) {
                            documents = documents.concat(response.results);
                        }
                        else {
                            documents = response.results;
                        }
                        queryResLen = response.results.length;
                        count++;
                        return [3 /*break*/, 1];
                    case 3:
                        duration = Date.now() - startTime;
                        this.log.info({
                            object: this.ike.className,
                            found: documents.length,
                            keys: Object.keys(this.where).join(', '),
                            duration: duration
                        }, 'find');
                        return [2 /*return*/, documents];
                }
            });
        });
    };
    IkeRestQuery.prototype.findOne = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var documents;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.limitResults = 1;
                        return [4 /*yield*/, this.find()];
                    case 1:
                        documents = _a.sent();
                        return [2 /*return*/, documents[0]];
                }
            });
        });
    };
    return IkeRestQuery;
}());
exports.IkeRestQuery = IkeRestQuery;
//# sourceMappingURL=query.js.map